<script lang="ts">
    type AVAILABLE_IMAGE_SIZES = 40 | 80 | 360 | 720 | 980 | 1440;

    interface SizeMapping {
        constraint?: string;
        size: AVAILABLE_IMAGE_SIZES;
    }

    export let url: string;
    export let sizeMappings: SizeMapping[] = [];
    export let alt: string;

    let srcsetBuilder = [];
    let srcsetWebpBuilder = [];
    let sizesBuilder = [];

    $: {
        srcsetBuilder = [];
        sizesBuilder = [];
        srcsetWebpBuilder = [];
        sizeMappings.forEach((sizeMapping) => {
            srcsetBuilder.push(
                `https://glosbe.com/fb_img/${sizeMapping.size}x${sizeMapping.size}/${url} ${sizeMapping.size}w`
            );
            srcsetWebpBuilder.push(
                `https://glosbe.com/fb_img/${sizeMapping.size}x${sizeMapping.size}/${url}.cvrt.webp ${sizeMapping.size}w`
            );
            sizesBuilder.push(
                `${sizeMapping.constraint || ""} ${sizeMapping.size}px`
            );
        });
    }
</script>

<picture>
    <source
        type="image/webp"
        srcset={srcsetWebpBuilder.join(',')}
        sizes={sizesBuilder.join(',')} />
    <img
        src="https://glosbe.com/fb_img/80x80/{url}"
        {alt}
        srcset={srcsetBuilder.join(',')}
        sizes={sizesBuilder.join(',')}
        loading="lazy"
        class={$$props.class || ''} />
</picture>
